import { create } from 'zustand';

export const APP_LANGUAGES = [
  { value: 'pl', label: 'PL' },
  { value: 'en', label: 'EN' },
  { value: 'de', label: 'DE' },
];

const DEFAULT_LANGUAGE = 'pl';

export const sanitizeLanguage = (value) => {
  if (!value) return DEFAULT_LANGUAGE;
  const normalized = String(value).trim().toLowerCase();
  return APP_LANGUAGES.some((language) => language.value === normalized) ? normalized : DEFAULT_LANGUAGE;
};

export const APP_TRANSLATIONS = {
  pl: {
    language: 'Język',
    theme: 'Motyw',
    roles: 'Role',
    userPanel: 'Panel użytkownika',
    userPanelSubtitle: 'Widok dostosowany do aktywnej roli',
    appVersion: 'Wersja aplikacji',
    build: 'Build',
    loadingView: 'Ładowanie widoku...',
    loadingDesc: 'Trwa przygotowanie modułu strony. To zwykle zajmuje 1-4 sekundy przy pierwszym otwarciu.',
    loginTitle: 'Logowanie do PKK 99',
    loginSubtitle: 'Strona startowa zawiera tylko panel logowania.',
    liveModeRequired: 'Tryb LIVE wymaga ustawionych danych Firebase.',
    emailPasswordError: 'Email lub hasło jest niepoprawne',
    googleLoginError: 'Błąd podczas logowania przez Google',
    demoLoginError: 'Nie udało się uruchomić trybu demo',
    googleLogin: 'Zaloguj się przez Google',
    demoLogin: 'Uruchom tryb demo',
    demoDescription: 'Tryb demo działa bez Firestore i bez kont logowania.',
    liveDescription: 'Rejestracja kont odbywa się przez administratora klubu.',
    loginSuccess: 'Zalogowano pomyślnie!',
    demoLaunchSuccess: 'Uruchomiono tryb demo',
    login: 'Logowanie',
    email: 'Email',
    password: 'Hasło',
    showPassword: 'Pokaż hasło',
    hidePassword: 'Ukryj hasło',
    loggingIn: 'Logowanie...',
    loginButton: 'Zaloguj się',
    registerTitle: 'Rejestracja',
    fullName: 'Imię i nazwisko',
    confirmPassword: 'Potwierdź hasło',
    refreshPage: 'Odśwież stronę',
    homePage: 'Strona główna',
    errorTitle: 'Wystąpił błąd',
    errorDescription1: 'Przepraszamy, wystąpił nieoczekiwany błąd w aplikacji.',
    errorDescription2: 'Możesz spróbować odświeżyć stronę lub wrócić do strony głównej.',
    errorDetails: 'Szczegóły błędu (kliknij, aby rozwinąć)',
    userFallback: 'Użytkownik',
    dashboard: 'Dashboard',
    activities: 'Aktywności',
    training: 'Trening',
    calendar: 'Kalendarz',
    stats: 'Statystyki',
    challenges: 'Wyzwania',
    groups: 'Grupy',
    help: 'Pomoc',
    privacy: 'Prywatność i dozwolone użycie',
    logout: 'Wyloguj się',
    openMenu: 'Otwórz menu',
    closeMenu: 'Zamknij menu',
    basics: 'Podstawy',
    development: 'Rozwój i wyniki',
    management: 'Zarządzanie',
    helpAndFormality: 'Pomoc i formalności',
    playerPanel: 'Panel Zawodnika',
    trainerPanel: 'Panel Trenera',
    adminPanel: 'Panel Admina',
    start: 'Start',
    mobileNavAria: 'Nawigacja dolna',
    newVersionTitle: '📲 Nowa wersja dostępna!',
    newVersionText: 'Aplikacja została uaktualniona. Załaduj nową wersję, aby korzystać z najnowszych funkcji.',
    updating: 'Aktualizuję...',
    updateNow: 'Zaktualizuj teraz',
    closeUpdate: 'Zamknij powiadomienie o aktualizacji',
    activitiesPageTitle: 'Aktywności',
    activitiesPageSubtitle: 'Jedno miejsce do zarządzania ćwiczeniami i gotowymi planami treningowymi.',
    exerciseCardTitle: 'Ćwiczenia',
    exerciseCardText: 'Edytuj bazę ćwiczeń, importuj dane i uruchamiaj podgląd filmów instruktażowych.',
    openExercises: 'Otwórz ćwiczenia',
    workoutsCardTitle: 'Treningi',
    workoutsCardText: 'Buduj gotowe jednostki treningowe i uruchamiaj je bezpośrednio z listy treningów.',
    openWorkouts: 'Otwórz treningi',
    workoutCardTitle: 'Trening',
    workoutCardText: 'Widok wykonania treningu: lektor, przerwy, nawodnienie i odtwarzanie filmów YouTube.',
    openWorkout: 'Otwórz trening',
    helpPageTitle: 'Pomoc',
    helpPageSubtitle: 'Kompletny opis funkcji oraz instrukcje instalacji skrótu aplikacji.',
    helpAppDescription: 'Jak działa aplikacja',
    appShortcutTitle: 'Skrót aplikacji na ekranie',
    securityTitle: 'Bezpieczeństwo, AI i zgodność',
    privacyPageTitle: 'Prywatność i dozwolone użycie',
    privacyPageSubtitle: 'Dokument określa zasady przetwarzania danych i warunki korzystania z aplikacji PKK Training.',
    privacySectionTitle: 'Polityka prywatności',
    usageSectionTitle: 'Dozwolone użycie (Terms of Use)',
    proceduresSectionTitle: 'Procedury zgłoszeń',
    lastUpdated: 'Ostatnia aktualizacja',
    notFoundTitle: 'Strona nie znaleziona',
    notFoundMessage: 'Przepraszamy, ale strona której szukasz nie istnieje lub została przeniesiona.',
    notFoundReasonsTitle: 'Możliwe przyczyny:',
    notFoundReason1: 'Błąd w adresie URL',
    notFoundReason2: 'Strona została usunięta',
    notFoundReason3: 'Brak uprawnień do przeglądania tej strony',
    notFoundReason4: 'Problem z serwerem',
    backToHome: 'Powrót do strony głównej',
    error404: 'Błąd 404: Strona nie istnieje',
    dashboardWelcome: 'Witaj,',
    activeRoleView: 'Aktywny widok roli',
    switchRole: 'Przełącz widok roli',
    roleManagement: 'Szybkie zarządzanie dostępem do modułów',
    noUrgentActions: 'Brak pilnych działań. Najważniejsze moduły są dostępne z menu bocznego.',
    myRole: 'Moja rola',
    assignedRoles: 'Przydzielone role:',
    trainerAdminOnly: 'Uprawnienia trenera i admina może nadać wyłącznie konto z rolą admin.',
    trainingToday: 'Treningu dzisiaj',
    exercisesCompleted: 'Ćwiczeń wykonanych',
    trainingTime: 'Czas treningu',
    minShort: 'min',
    rankingPosition: 'Pozycja w rankingu',
    weeklyTarget: 'Tygodniowo',
    monthlyTarget: 'Miesięcznie',
    agendaTitle: 'Agenda na dziś',
    noAgenda: 'Brak wydarzeń w harmonogramie na dzisiaj.',
    groupNotifications: 'Powiadomienia grupowe',
    noNotifications: 'Brak nowych powiadomień od trenera lub admina.',
    shotTestTitle: 'Test rzutowy 20/20/20',
    savingShot: 'Zapisywanie...',
    saveShot: 'Zapisz test rzutowy',
    accuracyTotal: 'Skuteczność całkowita',
    shotsRecent: 'Ostatnie zapisy',
    noShotLogs: 'Brak zapisanych testów rzutowych.',
  },
  en: {
    language: 'Language',
    theme: 'Theme',
    roles: 'Roles',
    userPanel: 'User panel',
    userPanelSubtitle: 'View adapted to the active role',
    appVersion: 'App version',
    build: 'Build',
    loadingView: 'Loading view...',
    loadingDesc: 'Preparing the page module. This usually takes 1-4 seconds on the first open.',
    loginTitle: 'PKK 99 Login',
    loginSubtitle: 'The landing page contains only the login panel.',
    liveModeRequired: 'LIVE mode requires Firebase data to be configured.',
    emailPasswordError: 'Email or password is incorrect',
    googleLoginError: 'An error occurred while logging in with Google',
    demoLoginError: 'Unable to start demo mode',
    googleLogin: 'Sign in with Google',
    demoLogin: 'Launch demo mode',
    demoDescription: 'Demo mode works without Firestore or login accounts.',
    liveDescription: 'Account registration is handled by the club administrator.',
    loginSuccess: 'Logged in successfully!',
    demoLaunchSuccess: 'Demo mode started',
    login: 'Login',
    email: 'Email',
    password: 'Password',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    loggingIn: 'Logging in...',
    loginButton: 'Log in',
    registerTitle: 'Registration',
    fullName: 'Full name',
    confirmPassword: 'Confirm password',
    refreshPage: 'Refresh page',
    homePage: 'Home',
    errorTitle: 'An error occurred',
    errorDescription1: 'Sorry, an unexpected error occurred in the application.',
    errorDescription2: 'You can try refreshing the page or returning to the home page.',
    errorDetails: 'Error details (click to expand)',
    userFallback: 'User',
    dashboard: 'Dashboard',
    activities: 'Activities',
    training: 'Training',
    calendar: 'Calendar',
    stats: 'Statistics',
    challenges: 'Challenges',
    groups: 'Groups',
    help: 'Help',
    privacy: 'Privacy and permitted use',
    logout: 'Log out',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    basics: 'Basics',
    development: 'Development and results',
    management: 'Management',
    helpAndFormality: 'Help and formalities',
    playerPanel: 'Player Panel',
    trainerPanel: 'Coach Panel',
    adminPanel: 'Admin Panel',
    start: 'Start',
    mobileNavAria: 'Bottom navigation',
    newVersionTitle: '📲 A new version is available!',
    newVersionText: 'The app has been updated. Reload the new version to use the latest features.',
    updating: 'Updating...',
    updateNow: 'Update now',
    closeUpdate: 'Close update notification',
    activitiesPageTitle: 'Activities',
    activitiesPageSubtitle: 'One place to manage exercises and ready-made training plans.',
    exerciseCardTitle: 'Exercises',
    exerciseCardText: 'Edit the exercise database, import data and preview instructional videos.',
    openExercises: 'Open exercises',
    workoutsCardTitle: 'Workouts',
    workoutsCardText: 'Build ready-made training units and launch them directly from the workout list.',
    openWorkouts: 'Open workouts',
    workoutCardTitle: 'Training',
    workoutCardText: 'Training execution view: narrator, breaks, hydration and YouTube video playback.',
    openWorkout: 'Open training',
    helpPageTitle: 'Help',
    helpPageSubtitle: 'Complete description of features and installation instructions for the app shortcut.',
    helpAppDescription: 'How the app works',
    appShortcutTitle: 'App shortcut on the screen',
    securityTitle: 'Security, AI and compliance',
    privacyPageTitle: 'Privacy and permitted use',
    privacyPageSubtitle: 'This document defines data processing rules and the terms of use for the PKK Training app.',
    privacySectionTitle: 'Privacy policy',
    usageSectionTitle: 'Allowed use (Terms of Use)',
    proceduresSectionTitle: 'Reporting procedures',
    lastUpdated: 'Last update',
    notFoundTitle: 'Page not found',
    notFoundMessage: 'Sorry, the page you are looking for does not exist or has been moved.',
    notFoundReasonsTitle: 'Possible causes:',
    notFoundReason1: 'Error in the URL',
    notFoundReason2: 'Page was removed',
    notFoundReason3: 'You do not have permission to view this page',
    notFoundReason4: 'Server problem',
    backToHome: 'Back to home',
    error404: 'Error 404: page does not exist',
    dashboardWelcome: 'Welcome,',
    activeRoleView: 'Active role view',
    switchRole: 'Switch role view',
    roleManagement: 'Quick management of access to modules',
    noUrgentActions: 'No urgent actions. The most important modules are available from the sidebar menu.',
    myRole: 'My role',
    assignedRoles: 'Assigned roles:',
    trainerAdminOnly: 'Only an admin account can grant trainer and admin permissions.',
    trainingToday: 'Training today',
    exercisesCompleted: 'Exercises completed',
    trainingTime: 'Training time',
    minShort: 'min',
    rankingPosition: 'Ranking position',
    weeklyTarget: 'Weekly',
    monthlyTarget: 'Monthly',
    agendaTitle: 'Today’s agenda',
    noAgenda: 'No scheduled events for today.',
    groupNotifications: 'Group notifications',
    noNotifications: 'No new notifications from the coach or admin.',
    shotTestTitle: '20/20/20 shooting test',
    savingShot: 'Saving...',
    saveShot: 'Save shooting test',
    accuracyTotal: 'Total accuracy',
    shotsRecent: 'Recent entries',
    noShotLogs: 'No saved shooting tests.',
  },
  de: {
    language: 'Sprache',
    theme: 'Thema',
    roles: 'Rollen',
    userPanel: 'Benutzerbereich',
    userPanelSubtitle: 'Ansicht angepasst an die aktive Rolle',
    appVersion: 'App-Version',
    build: 'Build',
    loadingView: 'Ansicht wird geladen...',
    loadingDesc: 'Das Seitenmodul wird vorbereitet. Das dauert beim ersten Öffnen normalerweise 1–4 Sekunden.',
    loginTitle: 'PKK 99 Anmeldung',
    loginSubtitle: 'Die Startseite enthält nur das Anmeldepanel.',
    liveModeRequired: 'Der LIVE-Modus erfordert konfigurierte Firebase-Daten.',
    emailPasswordError: 'E-Mail oder Passwort ist falsch',
    googleLoginError: 'Beim Anmelden mit Google ist ein Fehler aufgetreten',
    demoLoginError: 'Demo-Modus konnte nicht gestartet werden',
    googleLogin: 'Mit Google anmelden',
    demoLogin: 'Demo-Modus starten',
    demoDescription: 'Der Demo-Modus funktioniert ohne Firestore und ohne Login-Konten.',
    liveDescription: 'Die Kontoregistrierung erfolgt über den Club-Administrator.',
    loginSuccess: 'Erfolgreich angemeldet!',
    demoLaunchSuccess: 'Demo-Modus gestartet',
    login: 'Anmeldung',
    email: 'E-Mail',
    password: 'Passwort',
    showPassword: 'Passwort anzeigen',
    hidePassword: 'Passwort ausblenden',
    loggingIn: 'Anmeldung läuft...',
    loginButton: 'Anmelden',
    registerTitle: 'Registrierung',
    fullName: 'Vollständiger Name',
    confirmPassword: 'Passwort bestätigen',
    refreshPage: 'Seite aktualisieren',
    homePage: 'Startseite',
    errorTitle: 'Ein Fehler ist aufgetreten',
    errorDescription1: 'Es tut uns leid, in der Anwendung ist ein unerwarteter Fehler aufgetreten.',
    errorDescription2: 'Sie können die Seite aktualisieren oder zur Startseite zurückkehren.',
    errorDetails: 'Fehlerdetails (zum Ausklappen klicken)',
    userFallback: 'Benutzer',
    dashboard: 'Dashboard',
    activities: 'Aktivitäten',
    training: 'Training',
    calendar: 'Kalender',
    stats: 'Statistiken',
    challenges: 'Herausforderungen',
    groups: 'Gruppen',
    help: 'Hilfe',
    privacy: 'Datenschutz und erlaubte Nutzung',
    logout: 'Abmelden',
    openMenu: 'Menü öffnen',
    closeMenu: 'Menü schließen',
    basics: 'Grundlagen',
    development: 'Entwicklung und Ergebnisse',
    management: 'Verwaltung',
    helpAndFormality: 'Hilfe und Formalitäten',
    playerPanel: 'Spielerbereich',
    trainerPanel: 'Trainerbereich',
    adminPanel: 'Adminbereich',
    start: 'Start',
    mobileNavAria: 'Untere Navigation',
    newVersionTitle: '📲 Eine neue Version ist verfügbar!',
    newVersionText: 'Die App wurde aktualisiert. Laden Sie die neue Version, um die neuesten Funktionen zu nutzen.',
    updating: 'Aktualisierung läuft...',
    updateNow: 'Jetzt aktualisieren',
    closeUpdate: 'Update-Benachrichtigung schließen',
    activitiesPageTitle: 'Aktivitäten',
    activitiesPageSubtitle: 'Ein Ort zum Verwalten von Übungen und fertigen Trainingsplänen.',
    exerciseCardTitle: 'Übungen',
    exerciseCardText: 'Bearbeiten Sie die Übungsdatenbank, importieren Sie Daten und betrachten Sie Anleitungsvideos.',
    openExercises: 'Übungen öffnen',
    workoutsCardTitle: 'Trainings',
    workoutsCardText: 'Erstellen Sie fertige Trainingseinheiten und starten Sie sie direkt aus der Trainingsliste.',
    openWorkouts: 'Trainings öffnen',
    workoutCardTitle: 'Training',
    workoutCardText: 'Training-Ausführungsansicht: Stimme, Pausen, Flüssigkeitsaufnahme und YouTube-Videowiedergabe.',
    openWorkout: 'Training öffnen',
    helpPageTitle: 'Hilfe',
    helpPageSubtitle: 'Vollständige Funktionsbeschreibung und Installationsanleitung für die App-Verknüpfung.',
    helpAppDescription: 'So funktioniert die App',
    appShortcutTitle: 'App-Verknüpfung auf dem Bildschirm',
    securityTitle: 'Sicherheit, KI und Compliance',
    privacyPageTitle: 'Datenschutz und erlaubte Nutzung',
    privacyPageSubtitle: 'Dieses Dokument regelt die Datenschutzbestimmungen und Nutzungsbedingungen der PKK Training App.',
    privacySectionTitle: 'Datenschutzerklärung',
    usageSectionTitle: 'Erlaubte Nutzung (Nutzungsbedingungen)',
    proceduresSectionTitle: 'Meldeverfahren',
    lastUpdated: 'Letzte Aktualisierung',
    notFoundTitle: 'Seite nicht gefunden',
    notFoundMessage: 'Es tut uns leid, die von Ihnen gesuchte Seite existiert nicht oder wurde verschoben.',
    notFoundReasonsTitle: 'Mögliche Ursachen:',
    notFoundReason1: 'Fehler in der URL',
    notFoundReason2: 'Seite wurde entfernt',
    notFoundReason3: 'Sie haben keine Berechtigung, diese Seite anzuzeigen',
    notFoundReason4: 'Serverproblem',
    backToHome: 'Zur Startseite',
    error404: 'Fehler 404: Seite existiert nicht',
    dashboardWelcome: 'Willkommen,',
    activeRoleView: 'Aktive Rollenansicht',
    switchRole: 'Rollenansicht wechseln',
    roleManagement: 'Schnelle Verwaltung des Zugangs zu Modulen',
    noUrgentActions: 'Keine dringenden Aktionen. Die wichtigsten Module sind im Seitenmenü verfügbar.',
    myRole: 'Meine Rolle',
    assignedRoles: 'Zugewiesene Rollen:',
    trainerAdminOnly: 'Nur ein Admin-Konto kann Trainer- und Admin-Berechtigungen vergeben.',
    trainingToday: 'Training heute',
    exercisesCompleted: 'Abgeschlossene Übungen',
    trainingTime: 'Trainingszeit',
    minShort: 'min',
    rankingPosition: 'Rangposition',
    weeklyTarget: 'Wöchentlich',
    monthlyTarget: 'Monatlich',
    agendaTitle: 'Agenda für heute',
    noAgenda: 'Keine geplanten Ereignisse für heute.',
    groupNotifications: 'Gruppenbenachrichtigungen',
    noNotifications: 'Keine neuen Benachrichtigungen von Trainer oder Admin.',
    shotTestTitle: '20/20/20-Schusstest',
    savingShot: 'Wird gespeichert...',
    saveShot: 'Schusstest speichern',
    accuracyTotal: 'Gesamtgenauigkeit',
    shotsRecent: 'Letzte Einträge',
    noShotLogs: 'Keine gespeicherten Schusstests.',
  },
};

export const getAppText = (language) => APP_TRANSLATIONS[sanitizeLanguage(language)] || APP_TRANSLATIONS.pl;

export const useLanguageStore = create((set) => ({
  appLanguage: DEFAULT_LANGUAGE,

  setAppLanguage: (nextLanguage) => {
    const resolvedLanguage = sanitizeLanguage(nextLanguage);
    if (typeof localStorage !== 'undefined') localStorage.setItem('appLanguage', resolvedLanguage);
    set({ appLanguage: resolvedLanguage });
  },

  initLanguage: () => {
    const savedLanguage = typeof localStorage !== 'undefined' ? sanitizeLanguage(localStorage.getItem('appLanguage')) : DEFAULT_LANGUAGE;
    set({ appLanguage: savedLanguage });
  },
}));
